import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdateJobLocationDetailsRequest extends BaseUpdateRequest {
    locationId: string;
    contactId: string;
}